import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import logo from './extracted-scanned-text.png';
import FooterEmail from './FooterEmail';

const DownloadTextPageLogin = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state;
  const { email, fileKey, txtDownloadUrl, docDownloadUrl, pages } = state || {};
  const isLoggedIn = !!localStorage.getItem('userEmail');

  // 🧠 Log para verificar si llegan datos desde navigate()
  useEffect(() => {
    console.log("📩 Datos recibidos en DownloadTextPageLogin:", state);

    // Si no hay datos, redirigimos automáticamente
    if (!state) {
      console.warn("⚠️ No hay datos en location.state. Redirigiendo...");
      navigate('/paymentgateway');
      return;
    }

    registerDownloadHistory();
  }, []);

  const registerDownloadHistory = async () => {
    if (!email || !fileKey) {
      console.error('Faltan datos para registrar el historial:', { email, fileKey });
      return;
    }

    try {
      console.log('📤 Enviando historial a Lambda:', { email, key: fileKey, pages });
      const response = await fetch(
        'https://tvd3oah3x2x24grrffwafl4ive0cmyaj.lambda-url.us-east-1.on.aws/',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email,
            key: fileKey,
            bucket: 'pdfextracttools',
            pages,
          }),
        }
      );

      const data = await response.json();
      console.log('✅ Historial registrado correctamente:', data);
    } catch (error) {
      console.error('❌ Error al registrar el historial:', error);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-100 flex flex-col items-center justify-center px-4">
      <div className="max-w-2xl w-full bg-white shadow-xl rounded-2xl p-8 text-center">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">🎉 Extracted Text Ready</h1>

        {/* Mostrar los datos que llegaron */}
        <div className="text-sm text-gray-600 mb-4">
          <p><b>Email:</b> {email || 'N/A'}</p>
          <p><b>File:</b> {fileKey || 'N/A'}</p>
          <p><b>Pages:</b> {pages || 'N/A'}</p>
        </div>

        {txtDownloadUrl || docDownloadUrl ? (
          <div className="flex flex-col sm:flex-row justify-center items-center gap-4 mb-6">
            {txtDownloadUrl && (
              <a
                href={txtDownloadUrl}
                download
                className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-xl transition-all shadow-md"
              >
                Download as .txt
              </a>
            )}
            {docDownloadUrl && (
              <a
                href={docDownloadUrl}
                download
                className="px-6 py-3 bg-green-600 hover:bg-green-700 text-white rounded-xl transition-all shadow-md"
              >
                Download as .docx
              </a>
            )}
          </div>
        ) : (
          <p className="text-gray-500">Loading your download links...</p>
        )}

        <img
          src={logo}
          alt="TacPDF Logo"
          className="w-40 mx-auto my-6 drop-shadow-lg rounded-lg"
        />

        <button
          onClick={() => navigate('/paymentgateway')}
          className="mt-4 px-5 py-3 bg-gray-800 hover:bg-gray-900 text-white rounded-xl transition-all"
        >
          Volver a Payment Gateway
        </button>
      </div>

      <div className="mt-10 w-full">
        <FooterEmail />
      </div>
    </div>
  );
};

export default DownloadTextPageLogin;